import { render } from "./CRM.vue?vue&type=template&id=ef0efe94"
import script from "./CRM.vue?vue&type=script&lang=js"
export * from "./CRM.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__